import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import {ValidationButton} from "@irati/ui/src/FormItem"
import Icon from "@irati/ui/src/Icon"

export const StyledButton = styled(Button)`
  margin-right: 5px;
  padding: 21px 30px;
  &:focus, &:active {
    padding: 21px 30px;
  }
`

export const StyledValidationButton = styled(ValidationButton)`
  margin-left: 5px;
  padding: 21px 30px;
  &:focus, &:active {
    padding: 21px 30px;
  }
`

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`

export const StyledIcon = styled(Icon)`
  position: absolute;
  left: 15px;
`
